import { ProductTileLayout } from "@omni/ui/brand/product/productTile/productTile.config";
import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { MouseEvent } from "react";

import { useProductComparisonBarContext } from "@/components/Product/ProductComparisonBar/context/productComparisonBar.context";
import { ProductTileRenditions } from "@/components/Product/ProductImage/mappedRenditions";
import { ProductTile } from "@/components/Product/ProductTile/productTile.container";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const Products = ({ className }: Props) => {
    const { t } = useGranite();

    const { products, remove } = useProductComparisonBarContext();

    const handleOnRemoveClick = (sku: string) => (event: MouseEvent) => {
        event.stopPropagation();
        event.preventDefault();
        remove(sku);
    };

    return (
        <div className={cn("tw:flex tw:flex-col tw:overflow-auto", className)}>
            {products.map((product, index) => (
                <div
                    className={"tw:mx-4 tw:mb-4 tw:first-of-type:mt-4"}
                    key={product.sku}
                >
                    <ProductTile
                        sku={product.sku}
                        product={product}
                        allowInstantAddToCart={false}
                        lazyLoadImage={false}
                        productTileConfig={{
                            border: true,
                            amountOfFeatures: 0,
                            imageRenditions: ProductTileRenditions,
                            horizontal: true,
                            components:
                                ProductTileLayout.COMPARISON_BAR_HORIZONTAL(),
                            columnFractions: [5, 7]
                        }}
                        analyticsContext={{
                            list: "product-comparison",
                            placement: index + 1
                        }}
                    >
                        <Button
                            onClick={handleOnRemoveClick(product.sku)}
                            className={"tw:absolute tw:right-0 tw:top-0"}
                            color={"transparent"}
                            type={"button"}
                            aria-label={t("accessibility.comparison.remove")}
                        >
                            <span className="las la-times"></span>
                        </Button>
                    </ProductTile>
                </div>
            ))}
        </div>
    );
};
